import {
	BigNum,
	L2OrderBook,
	MMOraclePriceData,
	OraclePriceData,
	PERCENTAGE_PRECISION_EXP,
	PRICE_PRECISION_EXP,
	QUOTE_PRECISION_EXP,
} from '@velocity-exchange/sdk';
import {
	MarketPriceState,
	ProcessedMarketData,
} from '@velocity-exchange/common';

export interface TransformedMarketData {
	l2Orderbook: L2OrderBook;
	marketPriceState: MarketPriceState;
	oracleData: OraclePriceData;
	mmOracleData?: MMOraclePriceData;
	slot: number;
}

export function transformMarketData(
	data: ProcessedMarketData,
	uncrossedL2Orderbook: L2OrderBook,
	uncrossDisabled: boolean
): TransformedMarketData {
	const l2Orderbook = {
		bids:
			(uncrossDisabled
				? data.deserializedData.bids
				: uncrossedL2Orderbook.bids) || [],
		asks:
			(uncrossDisabled
				? data.deserializedData.asks
				: uncrossedL2Orderbook.asks) || [],
	};

	return {
		l2Orderbook,
		marketPriceState: {
			bestBid: BigNum.from(
				data.deserializedData.bestBidPrice,
				PRICE_PRECISION_EXP
			),
			bestAsk: BigNum.from(
				data.deserializedData.bestAskPrice,
				PRICE_PRECISION_EXP
			),
			markPrice: BigNum.from(
				data.deserializedData.markPrice,
				PRICE_PRECISION_EXP
			),
			spreadPct: BigNum.from(
				data.deserializedData.spreadPct,
				PERCENTAGE_PRECISION_EXP
			),
			spreadQuote: BigNum.from(
				data.deserializedData.spreadQuote,
				QUOTE_PRECISION_EXP
			),
			slot: data.deserializedData.marketSlot,
		},
		oracleData: data.deserializedData.oracleData,
		slot: data.slot ?? 0,
		mmOracleData: data.deserializedData.mmOracleData,
	};
}
